import React from "react";
import "./DarkMode.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleHalfStroke } from "@fortawesome/free-solid-svg-icons";

const DarkMode = () => {
  const setDarkMode = () => {
    document.querySelector("body").setAttribute("data-theme", "dark");
  };

  const setLightMode = () => {
    document.querySelector("body").setAttribute("data-theme", "light");
  };

  const toggleTheme = () => {
    const body = document.querySelector("body");
    const isDarkMode = body.getAttribute("data-theme") === "dark";
    isDarkMode ? setLightMode() : setDarkMode();
  };

  return (
    <div className="dark-mode-wrapper" onClick={toggleTheme}>
      <label className="dark-mode-label nav__link">
        <FontAwesomeIcon
          icon={faCircleHalfStroke}
          className="circle-half-stroke"
        />
      </label>
    </div>
  );
};

export default DarkMode;
